import { render, staticRenderFns } from "./totalPedido.vue?vue&type=template&id=71780240&"
import script from "./totalPedido.vue?vue&type=script&lang=js&"
export * from "./totalPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports